import { ApiClientBase } from "api/ApiClientBase";
import qs from "qs";

class AttendanceApiClient extends ApiClientBase {
    getRegionSchoolsAttendance(regionId) {
        return this.get(`/api/v1/attendance/region/${regionId}/schools`).then((r) => r.data);
    }

    getMunicipalitySchoolsAttendance(municipalityId) {
        return this.get(`/api/v1/attendance/municipality/${municipalityId}/schools`).then(
            (r) => r.data,
        );
    }

    getSchoolGroupsAttendance(schoolId) {
        return this.get(`/api/v1/attendance/school/${schoolId}/groups`).then((r) => r.data);
    }

    buildGroupAttendanceReport({ groupId, format }) {
        return this.post(
            `api/v1/attendance/report/group/${groupId}/build?${qs.stringify({ format })}`,
        ).then((r) => r.data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AttendanceApiClient();
